<div class="full-height">
  <pp-common-components></pp-common-components>

  <div
    id="site"
    aria-label="site"
    class="site"
    [class.site--no-sidebar]="sidePanel?.hidden"
    [class.site--disabled]="isLoadingTable"
  >
    <div
      id="siteHeader"
      data-m-target="Work list menu"
      class="site__header"
      [class.site__header--disabled]="isLoadingTable"
    >
      <pp-site-options [ppDataFetched]="dataFetched" [ppIsOverview]="true"></pp-site-options>
    </div>

    <div class="site__body">
      <div data-m-target="Work list table" class="site__table-wrapper">
        @if (dataFetched) {
          <pp-site-table-overview (ppTableCreated)="hidePlaceholder()"></pp-site-table-overview>
        }

        @if (!tableCreated || !dataFetched) {
          <div>
            <div class="site__table-overlay">
              <pp-site-table-placeholder aria-label="Site Table Placeholder" />
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<router-outlet name="full"></router-outlet>
